import { useExtraRequestParameters } from '@/data/Content/_ExtraRequestParameters';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useSettings } from '@/data/Settings';
import { EmailDomainValidation } from '@/data/types/EmailDomainValidation';
import { getClientSideCommon } from '@/data/utils/getClientSideCommon';
import { transactionsValidateEmail } from 'integration/generated/transactions';
import { RequestParams } from 'integration/generated/transactions/http-client';
import { useCallback } from 'react';
import getValueByPathFromUnknown from '../../../utils/getValueByPathFromUnknown';

const validateEmailFetcher = async (
	storeId: string,
	email: string,
	params: RequestParams
): Promise<EmailDomainValidation> => {
	try {
		const data = await transactionsValidateEmail(true).validateEmail(storeId, { email }, params);
		return { email, valid: data?.response?.valid ?? null };
	} catch (error) {
		const errorName = getValueByPathFromUnknown(error, ['name']);
		if (errorName === 'AbortError') {
			throw error;
		}

		if ((error as { status?: number })?.status === 400) {
			return { email, valid: false };
		}
		return { email, valid: null };
	}
};

export const useValidateEmailDomain = () => {
	const { settings } = useSettings();
	const router = useNextRouter();
	const { storeId } = getClientSideCommon(settings, router);
	const params = useExtraRequestParameters();

	const resolveEmailDomain = useCallback(
		(email: string, signal?: AbortSignal): Promise<EmailDomainValidation> =>
			validateEmailFetcher(storeId, email, { ...params, signal }),
		[storeId, params]
	);

	return { resolveEmailDomain };
};
